export default __webpack_public_path__ + "static/media/illustration.1abcf9fd.svg";